export default __webpack_public_path__ + "static/media/unum-total-leave-logo.4069ebeb.svg";